import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
const MAX_FONT_SIZE = 14;
const MIN_FONT_SIZE = 6;
const CIRCLE_WIDTH = 20; // px, should match your CSS

const NoteCircleIcon = ({
  text
}) => {
  const spanRef = useRef();
  const [fontSize, setFontSize] = useState(MAX_FONT_SIZE);
  useEffect(() => {
    let size = MAX_FONT_SIZE;
    if (spanRef.current) {
      // Reset font size before measuring
      spanRef.current.style.fontSize = `${size}px`;
      // Try decreasing font size until it fits or hits min
      while (size > MIN_FONT_SIZE && spanRef.current.scrollWidth > CIRCLE_WIDTH - 4 // 4px for border/padding
      ) {
        size -= 1;
        spanRef.current.style.fontSize = `${size}px`;
      }
      setFontSize(size);
    }
  }, [text]);
  return /*#__PURE__*/React.createElement("span", {
    className: "annotation-toolbar-circle",
    style: {
      fontSize
    },
    ref: spanRef,
    "data-testid": `note-circle-icon-${text}`
  }, text.slice(0, 4));
};
NoteCircleIcon.propTypes = {
  text: PropTypes.string.isRequired
};
export default NoteCircleIcon;